module.exports = __webpack_public_path__ + "img/pathway-towards-set-in-asian-cities-infographic.58b86c75.png";